import "./style.css";
import { createApp } from "vue";
import App from "./App.vue";
import { router } from './router';

import { createAuth0Client } from '@auth0/auth0-spa-js';

import {
  Assets,
  extensions,
  ExtensionType,
  Resolver,
  resolveTextureUrl,
  ResolveURLParser,
} from "pixi.js";


import { loadBootBundles, initAssets } from './assets';
await initAssets();

const auth0 = await createAuth0Client({
  domain: 'dev-stonebound.eu.auth0.com',
  clientId: '8D1pYsEOgzglUN3RgWFKUOPyIUgj5IvN',
  authorizationParams: {
    redirect_uri: import.meta.env.VITE_SERVER_URL + '/login',
    audience: "stonebound-server",
  }
});
export const auth0Client = auth0;

export const resolveJsonUrl = {
    extension: ExtensionType.ResolveParser,
    test: (value: string): boolean => Resolver.RETINA_PREFIX.test(value) && value.endsWith('.json'),
    parse: resolveTextureUrl.parse,
} as ResolveURLParser;

extensions.add(resolveJsonUrl);

loadBootBundles();

await Assets.load('forest-tile.png')
// Init PixiJS assets with this asset manifest
//await Assets.loadBundle(['gui']);

// List all existing bundles names
// const allBundles = manifest.bundles.map((item) =>item.name);
// console.log('bundles:', allBundles);
// Assets.backgroundLoadBundle(allBundles);

createApp(App)
.use(router)
.mount("#app");
